import lazy from 'Snippets/LazyLoad'

export const LandingPage = lazy(() => import('./Landing'))

export const JavascriptPage = lazy(() => import('./Javascript'))

export const NeumorphismPage = lazy(() => import('./Neumorphism'))

export const ReactPage = lazy(() => import('./React'))

export const Unsubscribe = lazy(() => import('./Others/Unsubscribe'))

export const ComingSoon = lazy(() => import('./Others/ComingSoon'))

export const PageNotFound = lazy(() => import('./StatusCode/PageNotFound'))